const headerData = [{
		prop: "InvCode",
		label: "产品编码",
		columnwidth: 100,
	},
	{
		prop: "InvAddCode",
		label: "产品型号",
		columnwidth: 130,
	},
	{
		prop: "InvName",
		label: "产品名称",
	},
	{
		prop: "Quantity",
		label: "数量",
		columnwidth: 80,
	},
	{
		prop: "RegistrationNo",
		label: "注册证",
		columnwidth: 170,
	},
	{
		prop: "LEVEL3",
		label: "LEVEL3",
		columnwidth: 100,
	},
	{
		prop: "PurchaseRatioThd",
		label: "品类占比",
		columnwidth: 80,
	},
	{
		prop: "DetailRemark",
		label: "备注",
	}
];
export default headerData;